<div
  class="block w-full p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700"
>
  <h5
    class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white"
  >
    <span
      role="status"
      class="hidden sm:inline text-sky-600 dark:text-sky-500 font-bold"
      >{{ totalReports }}</span
    >
    Total Scheduled Reports
  </h5>
  <p
    *ngIf="totalReports === null"
    class="font-normal text-gray-700 dark:text-gray-400"
  >
    Loading...
  </p>

  <ng-container *ngIf="filteredCompanyDetails && filteredCompanyDetails.length === 1">
    <div
      class="mt-4 rounded-xl p-5 bg-gradient-to-br from-sky-50 to-white border border-sky-200 dark:from-sky-900/30 dark:to-gray-800 dark:border-sky-700/50"
    >
      <div class="flex items-center gap-3">
        <img
          class="w-12 h-12 rounded-full ring-2 ring-sky-300 dark:ring-sky-700"
          src="/assets/company.webp"
          alt="{{ filteredCompanyDetails[0].company_name }} logo"
        />
        <div class="flex-1 min-w-0">
          <p class="text-lg font-bold text-gray-900 dark:text-white truncate">
            {{ filteredCompanyDetails[0].company_name }}
          </p>
          <p class="text-xs text-gray-500 dark:text-gray-400">
            id_cia {{ filteredCompanyDetails[0].id_cia }}
            <span *ngIf="sessionRuc"> · RUC {{ sessionRuc }}</span>
          </p>
        </div>
      </div>

      <div
        class="mt-4 flex items-center justify-between rounded-lg bg-white/70 dark:bg-gray-900/50 px-4 py-3 ring-1 ring-sky-100 dark:ring-sky-800/50"
      >
        <div class="flex flex-col leading-tight">
          <span class="text-[11px] font-bold uppercase tracking-[0.12em] text-sky-700 dark:text-sky-400">
            Reportes
          </span>
          <span class="text-xs font-medium text-gray-500 dark:text-gray-400">
            programados
          </span>
        </div>
        <span class="text-3xl font-extrabold text-sky-600 dark:text-sky-400 tabular-nums">
          {{ filteredCompanyDetails[0].num_reports }}
        </span>
      </div>

      <div class="mt-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2">
          Tipo de programación
        </p>
        <div class="flex flex-wrap gap-1.5">
          <ng-container *ngFor="let t of typeOrder">
            <span
              *ngIf="typeCounts[t] > 0"
              class="text-xs font-semibold px-2.5 py-0.5 rounded"
              [ngClass]="typeBadgeClass(t)"
            >
              {{ t }} · {{ typeCounts[t] }}
            </span>
          </ng-container>
        </div>
      </div>

      <div class="mt-3">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2">
          Estado de última ejecución
        </p>
        <div class="flex flex-wrap gap-1.5">
          <ng-container *ngFor="let s of statusOrder">
            <span
              *ngIf="statusCounts[s] > 0"
              class="text-xs font-semibold px-2.5 py-0.5 rounded"
              [ngClass]="statusBadgeClass(s)"
            >
              {{ s }} · {{ statusCounts[s] }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <div
    *ngIf="filteredCompanyDetails && filteredCompanyDetails.length > 1"
    class="mt-4 flow-root"
  >
    <ul
      role="list"
      class="divide-y divide-gray-200 dark:divide-gray-700 max-h-96 overflow-y-auto pr-1"
    >
      <li
        *ngFor="let company of filteredCompanyDetails"
        class="py-3 sm:py-4 px-2 rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700"
        (click)="onCompanySelected(company)"
        [ngClass]="{
          'bg-sky-100 dark:bg-sky-900': selectedCompanyId === company.id_cia
        }"
      >
        <div class="flex items-center">
          <div class="shrink-0">
            <img
              class="w-8 h-8 rounded-full"
              src="/assets/company.webp"
              alt="{{ company.company_name }} logo"
            />
          </div>
          <div class="flex-1 min-w-0 ms-4">
            <p
              class="text-sm font-medium text-gray-900 truncate dark:text-white"
            >
              {{ company.company_name }}
            </p>
            <p class="text-sm text-gray-500 truncate dark:text-gray-400">
              id_cia {{ company.id_cia }}
            </p>
          </div>
          <div
            class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white"
          >
            {{ company.num_reports }} reports
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
